import React, { Component } from "react";
import GroupNumberTooltip from "../../GroupNumberTooltip/GroupNumberTooltip";
import "./icons.scss";

class GroupNumberIcon extends Component {
	constructor(props) {
		super(props);

		this.domEl = this.props.domElement;
		this.groupNumber = this.props.groupNumber;
	}

	onMouseOver = (e, groupNumberArray) => {
		if (groupNumberArray) {
			const count = groupNumberArray.length;
			groupNumberArray = (
				<ul className="groupNumberList">
					{groupNumberArray.map((number, index) => {
						return <li key={`${this.domEl}_${number}_${index}`}>{number}</li>;
					})}
				</ul>
			);
			const dimensions = document.querySelector(`#${this.props.domElement}`)?.getBoundingClientRect();
			if (dimensions) {
				GroupNumberTooltip.updateGroupNumber(e, groupNumberArray, dimensions, "group_number_placements", count);
			}
		}
	};

	onMouseOut = (e) => {
		GroupNumberTooltip.closeOpenGroupNumber(e);
	};

	renderGroupNumberElement = (groupNumber) => {
		const groupNumberArray = groupNumber.split(",").map((number) => {
			return number.trim();
		});
		if (groupNumberArray.length > 1) {
			return (
				<span>
					{groupNumberArray[0]}
					<i className="icon-info groupNumberIcon" onMouseOver={(e) => this.onMouseOver(e, groupNumberArray)} onMouseOut={this.onMouseOut} />
				</span>
			);
		}
		return groupNumber;
	};

	render() {
		const domEl = this.props.domElement;
		const { groupNumber } = this.props;
		const groupNumberElement = this.renderGroupNumberElement(groupNumber);

		return (
			<div className="icon__container">
				<div id={domEl} className="icon">
					{groupNumberElement}
				</div>
			</div>
		);
	}
}

export default GroupNumberIcon;
